"use client";

import { SLLink } from "@/components/i18n/SLLink";
import { assetPaths } from "@/lib/assetPaths";
import { Box } from "@mui/material";
import Image from "next/image";

export function SLNavigationLogo() {
  return (
    <Box
      sx={{
        width: { xs: "fit-content", md: "100%" },
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: { xs: "90px", md: "120px" },
          height: { xs: "80px", md: "110px" },
        }}
      >
        <SLLink
          href="/"
          style={{
            textDecoration: "none",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            width: "100%",
            height: "100%",
          }}
        >
          <Image
            style={{
              objectFit: "contain",
              objectPosition: "center",
            }}
            src={assetPaths.logos.black}
            alt="Solving Legal - Return to homepage"
            fill={true}
          />
        </SLLink>
      </Box>
    </Box>
  );
}
